// Vendor
import * as React from 'react';

// Vendor Components
import Button, {ButtonProps} from 'material-ui/Button';
import {Link, LinkProps} from 'react-router-dom';

// Types
type ButtonLinkProps = ButtonProps & LinkProps;

export const ButtonLink: React.SFC<ButtonLinkProps> = ({
  to,
  replace,
  children,
  ...props
}) => (
  <Button
    {...props}
    component={props => <Link to={to} replace={replace} {...props} />}
  >
    {children}
  </Button>
);

ButtonLink.displayName = 'ButtonLink';

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/ui/components/button-link/button-link.tsx